export default __webpack_public_path__ + "static/media/snap-logo-01.da3b739f.png";